export class Contenant {
    static jsonMap = {
        idType: 'idType',
        nombre: 'nombre',
        volume: 'volume'
    };

    idType: number = undefined;
    nombre: number = undefined;
    volume: number = undefined;
}
